import script from "./DetailViewForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./DetailViewForm.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__